import { render, staticRenderFns } from "./MemoryChart.vue?vue&type=template&id=63324be9&scoped=true&"
import script from "./MemoryChart.vue?vue&type=script&lang=js&"
export * from "./MemoryChart.vue?vue&type=script&lang=js&"
import style0 from "./MemoryChart.vue?vue&type=style&index=0&id=63324be9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63324be9",
  null
  
)

export default component.exports